import React from 'react';

import './formRow.scss';

export const FormRow = ({children}) => {
  return <div className="formRow">{children}</div>;
};
